import {NodeParamsChunk} from "../chunks/types/NodeParamsChunk";
import {ChunkType} from "../chunks/types/ChunkType";
import {getParamNameFromNodeParamsItemChunk} from "./utils/getParamNameFromNodeParamsItemChunk";
import {getParamValueFromNodeParamsItemChunk} from "./utils/getParamValueFromNodeParamsItemChunk";

export function nodeParamsChunkToParams(
  nodeParamsChunk: NodeParamsChunk
): Record<string, any> {
  const result = {} as Record<string, any>;
  const {children = []} = nodeParamsChunk;
  for (const chunk of children) {
    if (chunk.type === ChunkType.NodeParamsItem) {
      const paramName = getParamNameFromNodeParamsItemChunk(chunk);
      result[paramName] = getParamValueFromNodeParamsItemChunk(chunk);
    }
  }
  return result;
}
